module.exports = {"231183100":"嫩江镇","231183101":"伊拉哈镇","231183102":"双山镇","231183103":"多宝山镇","231183104":"海江镇","231183105":"前进镇","231183106":"长福镇","231183107":"科洛镇","231183108":"霍龙门镇","231183202":"临江乡","231183206":"联兴乡","231183207":"白云乡","231183208":"塔溪乡","231183211":"长江乡","231183400":"多宝山铜矿","231183500":"九三管理局局直","231183501":"鹤山农场","231183502":"大西江农场","231183503":"尖山农场","231183504":"荣军农场","231183506":"七星泡农场","231183507":"嫩江农场","231183508":"山河农场","231183509":"嫩北农场","231183510":"建边农场","231183581":"马铃薯原种繁殖场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/231183.json
// module id = 888
// module chunks = 0